import { statusImages } from "../resources/js/icons";

export const panelTypes = [
    { id: 1, label: "DCR Panel (Subsidy)", subsidy: true },
    { id: 2, label: "Non DCR Panel (Without Subsidy)", subsidy: false },
];

export const mobilePannelTypes = [
    { id: 1, label: "DCR Panel", subsidy: true },
    { id: 2, label: "Non DCR Panel", subsidy: false },
];

export const VISIT_TYPE_OPTIONS = [
    { label: "Fresh", value: "FRESH" },
    { label: "Follow-up", value: "FOLLOW_UP" },
];

export const CONNECTION_PHASE_OPTIONS = [
    { label: "Single Phase", value: "Single" },
    { label: "Three Phase", value: "Three" },
];

export const YES_NO_OPTIONS = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
];

export const ROOF_TYPE_OPTIONS = [
    { label: "RCC", value: "RCC" },
    { label: "Metal Sheet", value: "METAL_SHEET" },
    { label: "Ground", value: "GROUND" },
];

export const FOLLOWUP_TYPE_OPTIONS = [
    { label: "Requirement Changes", value: "REQUIREMENT" },
    { label: "Proposal Revision", value: "REVISION" },
    { label: "Update Payment Terms", value: "PAYMENT" },
    { label: "Need More Time", value: "NEED_TIME" },
    { label: "General Question", value: "GENERAL" },
];

export const PROPOSAL_STAGE_OPTIONS = [
    { value: "HOT", label: "Hot", icon: statusImages.hot },
    { value: "COLD", label: "Cold", icon: statusImages.cold },
    { value: "MILD", label: "Mild", icon: statusImages.mild },
];

export const PAYMENT_OPTIONS = [
    {
        value: "DIRECT_PAYMENT",
        label: "Direct Payment",
        subLabel: "Cheque Payment",
    },
    {
        value: "PAYMENT_GATEWAY",
        label: "Payment Gateway",
        subLabel: "Razorpay PG",
    },
];

export const ACCOUNT_TYPE = [
    {
        label: "Current Account",
        value: "CURRENT_ACCOUNT",
    },
    {
        label: "Savings Account",
        value: "SAVINGS",
    },
];
